<div class="analytics-dashboard">
    <!-- Sub-tab navigation -->
    <div class="sub-tabs">
        <div *ngFor="let tab of subTabs"
             class="sub-tab"
             [class.active]="selectedTab === tab.id"
             (click)="onSubTabChange(tab.id)">
            {{ tab.labelKey | translate }}
        </div>
    </div>

    <!-- Tab content -->
    <div class="tab-content" [ngSwitch]="selectedTab">

        <!-- Engagement tab -->
        <div *ngSwitchCase="'engagement'">
            <!-- Filter Bar -->
            <div class="period-bar">
                <div class="period-buttons">
                    <button *ngFor="let p of periods"
                            class="period-button"
                            [class.active]="selectedPeriod === p.value"
                            (click)="onPeriodChange(p.value)">
                        {{ p.labelKey | translate }}
                    </button>
                </div>

                <div class="custom-dates" *ngIf="showCustomDates">
                    <label class="date-label">{{ 'pages.collections.analytics.from' | translate }}</label>
                    <input type="date" [(ngModel)]="customFrom" (change)="onCustomDateChange()" class="date-input">
                    <label class="date-label">{{ 'pages.collections.analytics.to' | translate }}</label>
                    <input type="date" [(ngModel)]="customTo" (change)="onCustomDateChange()" class="date-input">
                </div>

                <label class="compare-toggle">
                    <input type="checkbox" [checked]="comparePrevious" (change)="onCompareToggle()">
                    {{ 'pages.collections.analytics.compare_previous' | translate }}
                </label>
            </div>

            <!-- Loading State -->
            <div *ngIf="loading" class="loading-state">
                <mat-spinner diameter="40"></mat-spinner>
                <p>{{ 'pages.collections.analytics.loading' | translate }}</p>
            </div>

            <!-- Error State -->
            <div *ngIf="error && !loading" class="error-state">
                <mat-icon>error_outline</mat-icon>
                <p>{{ 'pages.collections.analytics.error' | translate }}</p>
                <button class="retry-button" (click)="retry()">{{ 'pages.collections.analytics.retry' | translate }}</button>
            </div>

            <!-- Dashboard Content -->
            <div *ngIf="!loading && !error && snapshot" class="dashboard-content">
                <app-collects-kpi-cards
                    [snapshot]="snapshot"
                    [comparePrevious]="comparePrevious">
                </app-collects-kpi-cards>

                <div class="charts-row-2col charts-row-equal">
                    <app-collects-area-users-chart
                        [data]="distribution?.byArea || []"
                        [areas]="areas">
                    </app-collects-area-users-chart>

                    <app-collects-area-chart
                        [data]="distribution?.byArea || []"
                        [areas]="areas">
                    </app-collects-area-chart>
                </div>

                <div class="charts-row-full">
                    <app-collects-heatmap
                        [points]="geo?.points || []"
                        [areas]="areas"
                        [coveragePercent]="geo?.coveragePercent"
                        [matchedCount]="geo?.matchedCount">
                    </app-collects-heatmap>
                </div>

                <div class="charts-row-2col">
                    <app-collects-views-trend
                        [currentData]="trends?.views?.current || []"
                        [previousData]="trends?.views?.previous">
                    </app-collects-views-trend>

                    <app-collects-downloads-trend
                        [currentData]="trends?.downloads?.current || []"
                        [previousData]="trends?.downloads?.previous">
                    </app-collects-downloads-trend>
                </div>
            </div>
        </div>

        <!-- Reminders tab -->
        <div *ngSwitchCase="'reminders'">
            <app-collects-reminder-analytics></app-collects-reminder-analytics>
        </div>

        <div *ngSwitchDefault class="placeholder">
            <p>{{ 'pages.collections.analytics.no_data' | translate }}</p>
        </div>

    </div>
</div>
